 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPS9780740790584_EPUB_CVI_R1 from '@/components/OEBPS/9780740790584_epub_cvi_r1'
 import LOVE_2 from '@/components/love_2'
 import OEBPS9780740790584_EPUB_HTP_R1 from '@/components/OEBPS/9780740790584_epub_htp_r1'
 import LOVE_1 from '@/components/love_1'
 import OEBPS9780740790584_EPUB_TP_R1 from '@/components/OEBPS/9780740790584_epub_tp_r1'
 import OEBPS9780740790584_EPUB_COP_R1 from '@/components/OEBPS/9780740790584_epub_cop_r1'
 import OEBPS9780740790584_EPUB_DED_R1 from '@/components/OEBPS/9780740790584_epub_ded_r1'
 import OEBPS9780740790584_EPUB_FORWORD_R1 from '@/components/OEBPS/9780740790584_epub_forword_r1'
 import OEBPS9780740790584_EPUB_BODY_R1 from '@/components/OEBPS/9780740790584_epub_body_r1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/9780740790584_epub_cvi_r1",
 			"name" : "OEBPS/9780740790584_epub_cvi_r1",
 			"component" : OEBPS9780740790584_EPUB_CVI_R1
 		},
 		{
 			"path" : "/love_2",
 			"name" : "love_2",
 			"component" : LOVE_2
 		},
 		{
 			"path" : "/OEBPS/9780740790584_epub_htp_r1",
 			"name" : "OEBPS/9780740790584_epub_htp_r1",
 			"component" : OEBPS9780740790584_EPUB_HTP_R1
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js